/**
 * Resolves a `var(--…)` token string to its computed value, for consumers that
 * can't read CSS custom properties (SVG data URLs, Google Maps overlays). Raw
 * values pass through.
 */
export function resolveTokenValue(value: string): string {
  const varName = value.match(/^var\((--[^)]+)\)$/)?.[1];
  if (!varName || typeof window === 'undefined') return value;

  return getComputedStyle(document.documentElement).getPropertyValue(varName).trim() || value;
}
